// src/theme/colors.js - Theme configuration for the application
export const theme = {
  colors: {
    primary: '#3b82f6',
    primaryHover: '#2563eb',
    secondary: '#6b7280',
    success: '#10b981',
    successHover: '#059669',
    error: '#ef4444',
    errorHover: '#dc2626',
    warning: '#f59e0b',
    info: '#06b6d4',
    
    // Background colors
    background: '#ffffff',
    cardBackground: '#ffffff',
    sectionBackground: '#f8fafc',
    border: '#e2e8f0',
    
    // Text colors
    text: {
      primary: '#1f2937',
      secondary: '#6b7280',
      muted: '#9ca3af',
      inverse: '#ffffff'
    },
    
    // State colors
    disabled: '#9ca3af',
    hover: '#f3f4f6',
    active: '#e5e7eb',
    
    // Photo upload specific colors
    upload: {
      dropzone: '#f9fafb',
      dropzoneHover: '#eff6ff',
      dropzoneBorder: '#d1d5db',
      dropzoneBorderHover: '#3b82f6',
      photoPreview: '#ffffff',
      photoPreviewBorder: '#e2e8f0',
      uploadProgress: '#3b82f6',
      uploadSuccess: '#10b981',
      uploadError: '#ef4444'
    }
  },
  
  // Border radius values
  borderRadius: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    full: '50%'
  },
  
  // Shadow values
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    modal: '0 25px 50px rgba(0, 0, 0, 0.25)'
  },
  
  // Spacing values
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    xxl: '2rem',
    xxxl: '3rem'
  },
  
  // Font sizes
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xxl: '1.5rem'
  },
  
  // Transitions
  transitions: {
    fast: '0.1s ease',
    normal: '0.2s ease',
    slow: '0.3s ease'
  }
};